"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var react_places_autocomplete_1 = __importStar(require("react-places-autocomplete"));
var trans_1 = __importDefault(require("@/plugins/trans"));
var MapPinIcon_1 = __importDefault(require("../icons/MapPinIcon"));
var LocationAutoComplete = function (_a) {
    var initialValue = _a.initialValue, onChange = _a.onChange;
    var _b = (0, react_1.useState)(initialValue || ''), value = _b[0], setValue = _b[1];
    // https://developers.google.com/maps/documentation/javascript/place-autocomplete#session_tokens
    // https://github.com/hibiken/react-places-autocomplete/issues/263
    var _c = (0, react_1.useState)(new google.maps.places.AutocompleteSessionToken()), sessionToken = _c[0], setSessionToken = _c[1];
    var handleChange = function (incomingAddress) {
        if (incomingAddress.length === 0) {
            onChange({ incomingAddress: '' });
        }
        setValue(incomingAddress);
    };
    var handleSelect = function (incomingAddress) {
        (0, react_places_autocomplete_1.geocodeByAddress)(incomingAddress)
            .then(function (results) { return __awaiter(void 0, void 0, void 0, function () {
            var result, latLng;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = results[0];
                        return [4 /*yield*/, (0, react_places_autocomplete_1.getLatLng)(result)];
                    case 1:
                        latLng = _a.sent();
                        return [2 /*return*/, __assign(__assign({}, latLng), { placeId: result.place_id })];
                }
            });
        }); })
            .then(function (secondResult) {
            setValue(incomingAddress);
            onChange(__assign(__assign({}, secondResult), { incomingAddress: incomingAddress }));
            setSessionToken(new google.maps.places.AutocompleteSessionToken());
        })
            .catch(function (error) { return console.error('Error', error); });
    };
    return ((0, jsx_runtime_1.jsx)(react_places_autocomplete_1.default, __assign({ debounce: 500, value: value, onChange: handleChange, onSelect: handleSelect, searchOptions: { sessionToken: sessionToken } }, { children: function (_a) {
            var getInputProps = _a.getInputProps, suggestions = _a.suggestions, getSuggestionItemProps = _a.getSuggestionItemProps, loading = _a.loading;
            return ((0, jsx_runtime_1.jsxs)("div", __assign({ style: { flexGrow: 1, position: 'relative' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.TextField, __assign({ fullWidth: true, sx: function (theme) { return ({
                            backgroundColor: '#fff',
                            borderRadius: '12px',
                            '& .MuiSvgIcon-root': {
                                color: theme.palette.primary.main,
                            },
                            '& .MuiInputBase-input': {
                                padding: '8px',
                            },
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderRadius: '12px',
                                },
                            },
                        }); }, InputProps: {
                            startAdornment: ((0, jsx_runtime_1.jsx)(material_1.InputAdornment, __assign({ position: "start" }, { children: (0, jsx_runtime_1.jsx)(MapPinIcon_1.default, {}) }))),
                        } }, getInputProps({
                        placeholder: trans_1.default.get('labels.frontend.search.where.placeholder'),
                    }))), (0, jsx_runtime_1.jsxs)(material_1.Paper, __assign({ sx: { position: 'absolute', zIndex: '12' } }, { children: [loading && (0, jsx_runtime_1.jsx)(material_1.LinearProgress, {}), suggestions.map(function (suggestion) { return (
                            // eslint-disable-next-line react/jsx-key
                            (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ sx: {
                                    padding: 4,
                                    cursor: 'pointer',
                                    '&:hover': {
                                        background: '#f1f1f1',
                                    },
                                }, variant: "body2" }, getSuggestionItemProps(suggestion), { children: (0, jsx_runtime_1.jsx)("span", { children: suggestion.description }) }))); })] }))] })));
        } })));
};
exports.default = LocationAutoComplete;
